<template>
  <span>
    <a
      target="_blank"
      class="hidden-lg-and-up"
      :href=getLink(hotelData)
      ><span id="whatsapp" style="font-size:36px" class="icon-whatsapp"></span></a
    >
    <a
      target="_blank"
      class="hidden-md-and-down"
      :href=getLink(hotelData)
      ><span id="whatsapp" style="font-size:36px" class="icon-whatsapp"></span></a
    >
  </span>
</template>

<script>
export default {
  props: {
      hotelData: {
          required: true
      }
  },
  name: "Whatsapp" ,
  methods : {
    getLink(hotelData) {
      let number = hotelData.phone;
      return 'https://wa.me/'+ number.replace(/\s/g, "") + '?text=¡Hola '+hotelData.name+'! Quisiera reservar...';
    },
  }
};
</script>

<style scoped>
#whatsapp {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 6%;
  width: 50px;
  height: 50px;
  right: 5%;
  background-color: #25d366;
  color: white;
  padding: 8px;
  border-radius: 50%;
  z-index: 999;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// WhatsappHotel.vue?c14ce094